import React from 'react';
import './Spinner.css';

/**
 * Shared Spinner Component
 * Provides consistent loading indicators across the application
 *
 * @param {string} size - Size variant: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} color - Color of spinner: 'primary', 'white', 'gray' (default: 'primary')
 * @param {string} className - Additional CSS classes
 */
const Spinner = ({ size = 'medium', color = 'primary', className = '' }) => {
  const sizeClass = `spinner--${size}`;
  const colorClass = `spinner--${color}`;

  return (
    <div
      className={`spinner ${sizeClass} ${colorClass} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="spinner__sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
